/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Dot = [["circle", { cx: "12.1", cy: "12.1", r: "1" }]];

export { Dot as default };
//# sourceMappingURL=dot.js.map
